// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
//import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"
import "controllers"

Rails.start()
//Turbolinks.start()
ActiveStorage.start()

// Mobile call event listener for tel: links
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const telLink = event.target.closest('a[href^="tel:"]')
    
    if (telLink) {
      const phoneNumber = telLink.href.replace('tel:', '').replace(/\s/g, '')
      
      // Get CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      
      // Send event to server (non-blocking, fire-and-forget)
      // Backend will search for contact by phone number
      fetch('/api/call_events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          phone_number: phoneNumber,
          source: 'mobile_web'
        })
      }).catch(error => {
        // Silent fail - don't block the call
        console.error('Failed to send call event:', error)
      })
    }
  })
})

